import React from 'react';

const resourceCards = [
  {
    id: 1,
    title: 'Search for a Provider',
    description: 'A handy how to guide on locating a doctor in your network',
    buttonText: 'LEARN MORE',
  },
  {
    id: 2,
    title: 'Using the Cigna Network',
    description: 'Learn more about how to best use the great Cigna network.',
    buttonText: 'LEARN MORE',
  },
  {
    id: 3,
    title: 'Using Telemedicine',
    description:
      'Learn how to set up appointments and use your free and convenient telemedicine service.',
    buttonText: 'LEARN MORE',
  },
  {
    id: 4,
    title: 'Using Alia Our AI Agent',
    description:
      "We'll guide you on how to get the most out of Alia, our AI Agent.",
    buttonText: 'LEARN MORE',
  },
  {
    id: 5,
    title: 'Filing a Claim',
    description:
      'We take the mystery out of filing claims and sho you how easy it is.',
    buttonText: 'LEARN MORE',
  },
  {
    id: 6,
    title: 'Survey',
    description:
      'We could love to get your feedback on how we are doing and what we can do better.',
    buttonText: 'TAKE SURVEY',
  },
];

export const ResourcesPage = () => {
  return (
    <div className="py-6">
      <div className="grid grid-cols-1 md:grid-cols-2 l:grid-cols-3 gap-6">
        {resourceCards.map((card) => (
          <div
            key={card.id}
            className="bg-white rounded-3xl max-md:rounded-2xl shadow-md overflow-hidden pb-10 max-1xl:pb-5 hover:shadow-lg transition-shadow duration-300 flex flex-col"
          >
            <div className="bg-profile-header-bg px-4 py-6 max-md:py-4.5 max-md:pl-6">
              <h3 className="text-[1.4vw] max-xl:text-[2vw] max-md:text-[3vw] max-sm:text-[4vw] text-white text-center max-sm:text-center max-md:text-left">
                {card.title}
              </h3>
            </div>

            <div className="p-4 flex flex-col max-md:flex-row max-sm:flex-col justify-between flex-grow items-center min-h-54 max-1xl:min-h-46 max-md:min-h-20">
              <p className="text-lg max-1xl:text-base text-center max-md:text-left max-sm:text-center max-w-[68%] max-1xl:max-w-[92%] max-md:max-w-[65%] max-sm:max-w-[80%] mt-5 max-1xl:mt-3 max-md:mt-0">
                {card.description}
              </p>

              <div className="flex justify-center">
                <button className="bg-primary text-white font-bold max-sm:mt-5 px-12 max-1xl:py-1.5 max-1xl:px-10 max-md:px-8 max-md:text-sm py-3 rounded-full text-lg hover:bg-red-900 duration-200">
                  {card.buttonText}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
